// Shared formatters — Saudi locale, RTL-friendly numbers.
export const sar = (n: number) =>
  new Intl.NumberFormat('ar-SA', { maximumFractionDigits: 0 }).format(n) + ' ر.س';

export const pct = (n: number) => `${n.toFixed(1)}%`;
